const AppleIcon = () => {
  return (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="4975"
      width="32"
      height="32"
    >
      <path
        d="M616.9 243c46.1-56.3 35.8-117.8 30.7-122.9-5.1-5.1-71.7 5.1-117.8 66.6-41 56.3-41 117.8-35.8 122.9C499.2 314.7 565.7 309.6 616.9 243L616.9 243zM729.6 529.8c-5.1-81.9 71.7-133.1 87-143.4l0-5.1c0 0-66.6-81.9-163.8-76.8-61.4 5.1-92.2 35.8-133.1 35.8-51.2 0-97.3-35.8-153.6-35.8-46.1 0-179.2 41-189.4 215-10.2 174.1 112.6 337.9 158.7 368.6 46.1 30.7 76.8 20.5 128-5.1 25.6-15.4 107.5-20.5 153.6 10.2 56.3 20.5 138.2 5.1 230.4-199.7C837.1 693.6 734.7 668 729.6 529.8L729.6 529.8zM729.6 529.8"
        fill="#000000"
        p-id="4976"
      ></path>
    </svg>
  );
};

export default AppleIcon;
